import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export function IncludesSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-161">
      <div className="max-w-3xl mx-auto" data-id="element-162">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-163">
          ¿Qué incluye el Pack Efemérides Listas?
        </h2>

        <div className="bg-blue-50 rounded-2xl p-5 border border-blue-100 mb-5" data-id="element-164">
          <h3 className="text-2xl font-bold mb-3 text-[#000000]" data-id="element-165">
            📚 Ebook principal con efemérides desarrolladas de marzo a diciembre
          </h3>

          <div className="flex justify-center mb-4" data-id="element-166">
            <a href="#compra" className="cursor-pointer hover:opacity-95 transition-opacity" data-id="element-167">
              <img src="https://cdn.magicpatterns.com/uploads/anbkPXfQGWewVMjCirizg3/MOCKAP_PRINCIPAL.png" alt="Pack Efemérides Listas" className="w-[180px] h-auto object-contain drop-shadow-lg rounded-lg" data-id="element-168" />
            </a>
          </div>

          <p className="text-lg font-medium mb-2" data-id="element-169">Cada fecha incluye:</p>

          <ul className="space-y-1.5 text-lg text-gray-800 mb-4 pl-4" data-id="element-170">
            <li className="flex items-start" data-id="element-171">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-172">•</span>
              <span data-id="element-173">explicación clara de la efeméride</span>
            </li>
            <li className="flex items-start" data-id="element-174">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-175">•</span>
              <span data-id="element-176">origen de la conmemoración</span>
            </li>
            <li className="flex items-start" data-id="element-177">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-178">•</span>
              <span data-id="element-179">qué ocurrió y por qué se recuerda</span>
            </li>
            <li className="flex items-start" data-id="element-180">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-181">•</span>
              <span data-id="element-182">personajes históricos importantes</span>
            </li>
            <li className="flex items-start" data-id="element-183">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-184">•</span>
              <span data-id="element-185">explicación adaptada para niños</span>
            </li>
            <li className="flex items-start" data-id="element-186">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-187">•</span>
              <span data-id="element-188">actividades para trabajar en clase</span>
            </li>
          </ul>

          <p className="text-lg font-bold text-gray-900 inline-block px-2 mb-2 bg-[#EFF6FF]" data-id="element-189">
            Todo pensado especialmente para Docentes de nivel Inicial y Primario
          </p>

          <p className="text-lg text-gray-700" data-id="element-190">
            El contenido está organizado para que puedas encontrar cada
            efeméride rápidamente y trabajarla en minutos.
          </p>
        </div>

        <div className="text-center mt-5" data-id="element-191">
          <CTAButton href="#compra" className="w-full md:w-auto" data-id="element-192">
            🔥 QUIERO RESOLVER MIS EFEMÉRIDES AHORA
          </CTAButton>
        </div>
      </div>
    </section>;
}